module.exports = __webpack_public_path__ + "img/icon-5.f2aa6076.png";